import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { TextField } from '@mui/material';
// import { Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import validateProfileForm from './ValidateProfileForm';
import * as accountActions from '../../actions/accountActions';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import * as Constants from '../../config/constants';
import * as loginActions from '../../actions/loginActions';

export default function ProfileContent() {
  console.log('Profile: - Profile screen loading...');
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [openFirstName, setOpenFirstName] = React.useState(false);
  const [openLastName, setOpenLastName] = React.useState(false);
  const [openPhone, setOpenPhone] = React.useState(false);

  const [showPassword] = useState(false);
  const [countryCode, setCountryCode] = useState(
    st !== undefined &&
      st.userDetail !== undefined &&
      st.userDetail.phone_number !== undefined &&
      st.userDetail.phone_number !== ''
      ? st.userDetail.phone_number.split(' ')[0] !== null
        ? st.userDetail.phone_number.slice(0, st.userDetail.phone_number.indexOf(' '))
        : '+1'
      : '+1'
  );
  const [saveFirstnameSubmitted, setSaveFirstnameSubmitted] = useState(false);
  const [saveLastnameSubmitted, setSaveLastnameSubmitted] = useState(false);
  const [savePhoneSubmitted, setSavePhoneSubmitted] = useState(false);

  useEffect(() => {
    //banner success message
    if (
      saveFirstnameSubmitted &&
      !st.isUpdateAccountFirstNameLoading &&
      st.updatefirstnameerror === ''
    ) {
      enqueueSnackbar(Constants.UPDATE_FIRSTNAME_SUCCESS, {
        variant: 'success'
      });
      setSaveFirstnameSubmitted(false);
      setOpenFirstName(false);
    }
    if (
      saveLastnameSubmitted &&
      !st.isUpdateAccountLastNameLoading &&
      st.updatelastnameerror === ''
    ) {
      enqueueSnackbar(Constants.UPDATE_LASTNAME_SUCCESS, {
        variant: 'success'
      });
      setSaveLastnameSubmitted(false);
      setOpenLastName(false);
    }

    if (savePhoneSubmitted && !st.isUpdateAccountPhoneLoading && st.updatephoneerror === '') {
      enqueueSnackbar(Constants.UPDATE_PHONE_SUCCESS, {
        variant: 'success'
      });
      setSavePhoneSubmitted(false);
      setOpenPhone(false);
    }
  }, [
    st.isUpdateAccountFirstNameLoading,
    saveFirstnameSubmitted,
    st.updatefirstnameerror,
    st.isUpdateAccountLastNameLoading,
    saveLastnameSubmitted,
    st.updatelastnameerror,
    savePhoneSubmitted,
    st.isUpdateAccountPhoneLoading,
    st.updatephoneerror
  ]);

  const handleEditFirstName = () => {
    setOpenFirstName(true);
  };
  const handleEditLastName = () => {
    setOpenLastName(true);
  };
  const handleEditPhone = () => {
    setOpenPhone(true);
  };

  const clickEditPassword = () => {
    navigate('/sop2web/changepassword');
  };
  return (
    <Formik
      // enableReinitialize={true}
      initialValues={{
        firstName: st !== undefined && st.userDetail !== undefined ? st.userDetail.given_name : '',
        lastName: st !== undefined && st.userDetail !== undefined ? st.userDetail.family_name : '',
        email: st !== undefined && st.userDetail !== undefined ? st.userDetail.email : '',
        phone: st !== undefined && st.userDetail !== undefined ? st.userDetail.phone_number : '',
        countryCode: countryCode,
        password: '12345678',
        newFirstname:
          st !== undefined && st.userDetail !== undefined ? st.userDetail.given_name : '',
        newLastname:
          st !== undefined && st.userDetail !== undefined ? st.userDetail.family_name : '',
        newPhone: st !== undefined && st.userDetail !== undefined ? st.userDetail.phone_number : '',
        error: ''
      }}
      validationSchema={validateProfileForm}>
      {(propsForm) => (
        <Box sx={styles.containerStyle}>
          <Box sx={styles.boxItemStyle}>
            <TextField
              variant="standard"
              size="small"
              margin="normal"
              id="firstname"
              label="First Name"
              name="firstname"
              autoComplete="firstname"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <Button
                    type="submit"
                    variant="standard"
                    onClick={handleEditFirstName}
                    sx={{
                      color: '#003087'
                    }}>
                    Edit
                  </Button>
                )
              }}
              value={propsForm.values.firstName}
              onChange={propsForm.handleChange('firstName')}
              error={propsForm.touched.firstName && Boolean(propsForm.errors.firstName)}
              helperText={propsForm.touched.firstName && propsForm.errors.firstName}
            />
            <Dialog open={openFirstName}>
              <DialogTitle>Update First Name</DialogTitle>
              <DialogContent>
                <DialogContentText></DialogContentText>
                <TextField
                  autoFocus
                  required
                  margin="normal"
                  // margin="dense"
                  name="newFirstname"
                  id="newFirstname"
                  label="First Name"
                  fullWidth
                  variant="standard"
                  value={propsForm.values.newFirstname}
                  onChange={propsForm.handleChange('newFirstname')}
                  error={Boolean(propsForm.errors.newFirstname)}
                  helperText={propsForm.errors.newFirstname}
                />
                <Typography style={styles.errorText}>{st.updatefirstnameerror}</Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    propsForm.values.newFirstname = propsForm.values.firstName;
                    propsForm.errors.newFirstname = '';
                    setOpenFirstName(false);
                    // reset error when navigate out
                    if (st.updatefirstnameerror !== '') dispatch(loginActions.clearError());
                  }}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (
                      propsForm.errors.newFirstname === undefined ||
                      propsForm.errors.newFirstname === ''
                    ) {
                      dispatch(
                        accountActions.requestUpdateFirstName(propsForm.values.newFirstname)
                      );
                      propsForm.values.firstName = propsForm.values.newFirstname;
                      //setOpenFirstName(false);
                      setSaveFirstnameSubmitted(true);
                    }
                  }}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          <Box sx={styles.boxItemStyle}>
            <TextField
              size="small"
              margin="normal"
              id="lastname"
              label="Last Name"
              name="lastname"
              autoComplete="lastname"
              variant="standard"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <Button
                    type="submit"
                    variant="standard"
                    onClick={handleEditLastName}
                    sx={{
                      color: '#003087'
                    }}>
                    Edit
                  </Button>
                )
              }}
              value={propsForm.values.lastName}
              onChange={propsForm.handleChange('lastName')}
              error={propsForm.touched.lastName && Boolean(propsForm.errors.lastName)}
              helperText={propsForm.touched.lastName && propsForm.errors.lastName}
            />
            <Dialog open={openLastName}>
              <DialogTitle>Update Last Name</DialogTitle>
              <DialogContent>
                <DialogContentText></DialogContentText>
                <TextField
                  autoFocus
                  required
                  margin="normal"
                  name="newLastname"
                  label="Last Name"
                  fullWidth
                  variant="standard"
                  value={propsForm.values.newLastname}
                  onChange={propsForm.handleChange('newLastname')}
                  error={Boolean(propsForm.errors.newLastname)}
                  helperText={propsForm.errors.newLastname}
                />
                <Typography style={styles.errorText}>{st.updatelastnameerror}</Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    propsForm.values.newLastname = propsForm.values.lastName;
                    propsForm.errors.newLastname = '';
                    setOpenLastName(false);
                    if (st.updatelastnameerror !== '') dispatch(loginActions.clearError());
                  }}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (
                      propsForm.errors.newLastname === undefined ||
                      propsForm.errors.newLastname === ''
                    ) {
                      dispatch(accountActions.requestUpdateLastName(propsForm.values.newLastname));
                      propsForm.values.lastName = propsForm.values.newLastname;
                      //setOpenLastName(false);
                      setSaveLastnameSubmitted(true);
                    }
                  }}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          <Box sx={styles.boxItemStyle}>
            <TextField
              size="small"
              margin="normal"
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              fullWidth
              variant="standard"
              InputProps={{
                readOnly: true
              }}
              value={propsForm.values.email}
              error={propsForm.touched.email && Boolean(propsForm.errors.email)}
              helperText={propsForm.touched.email && propsForm.errors.email}
            />
          </Box>
          <Box sx={styles.boxItemStyle}>
            <TextField
              size="small"
              label="Phone Number"
              // defaultCountry={'us'}
              variant="standard"
              fullWidth
              // disableCountryCode="true"
              // disableDropdown="true"
              // countryCodeEditable="false"
              sx={{ mt: 2 }}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <Button
                    type="submit"
                    variant="standard"
                    onClick={handleEditPhone}
                    sx={{
                      color: '#003087'
                    }}>
                    Edit
                  </Button>
                )
              }}
              value={propsForm.values.phone}
              // onChange={propsForm.handleChange('phone')}
              error={propsForm.touched.phone && Boolean(propsForm.errors.phone)}
              helperText={propsForm.touched.phone && propsForm.errors.phone}
            />
            <Dialog open={openPhone}>
              <DialogTitle>Update Phone</DialogTitle>
              <DialogContent>
                <DialogContentText></DialogContentText>
                <MuiPhoneNumber
                  size="small"
                  variant="standard"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={propsForm.values.newPhone}
                  onChange={(value, country) => {
                    console.log(country.dialCode);
                    if (value.includes(' ') && countryCode !== value.split(' ')[0]) {
                      setCountryCode(value.split(' ')[0]);
                      propsForm.setFieldValue('newPhone', value);
                    } else {
                      setCountryCode(country.dialCode);
                      propsForm.setFieldValue('newPhone', value);
                    }
                  }}
                  error={propsForm.touched.newPhone && Boolean(propsForm.errors.newPhone)}
                  helperText={propsForm.touched.newPhone && propsForm.errors.newPhone}
                />
                <Typography style={styles.errorText}>{st.updatephoneerror}</Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    propsForm.values.newphone = propsForm.values.phone;
                    propsForm.errors.phone = '';
                    setOpenPhone(false);
                    if (st.updatephoneerror !== '') dispatch(loginActions.clearError());
                  }}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (
                      propsForm.errors.newPhone === undefined ||
                      propsForm.errors.newPhone === ''
                    ) {
                      // insert a space after countryCode before save to database
                      let savePhone = propsForm.values.newPhone;
                      savePhone =
                        savePhone.substring(0, countryCode.length + 1) +
                        ' ' +
                        savePhone.substring(countryCode.length + 1, savePhone.length);
                      dispatch(accountActions.requestUpdatePhone(savePhone));
                      propsForm.values.phone = propsForm.values.newPhone;
                      //setOpenPhone(false);
                      setSavePhoneSubmitted(true);
                    }
                  }}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          <Box sx={styles.boxItemStyle}>
            <TextField
              size="small"
              margin="normal"
              variant="standard"
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <Button
                    type="submit"
                    variant="standard"
                    onClick={clickEditPassword}
                    sx={{
                      color: '#003087'
                    }}>
                    Edit
                  </Button>
                )
              }}
              value={propsForm.values.password}
              error={propsForm.touched.password && Boolean(propsForm.errors.password)}
              helperText={propsForm.touched.password && propsForm.errors.password}
            />
          </Box>
          <Box sx={styles.linkItemStyle}>
            <RouterLink
              variant="body1"
              color="inherit"
              sx={styles.linkTextStyle}
              component={RouterLink}
              to="/sop2web/home"
              onClick={() => {
                console.info('Navigate to home page.');
              }}>
              Back to View Cases
            </RouterLink>
          </Box>
          {/* </Box> */}
          {/* </Container> */}
        </Box>
      )}
    </Formik>
  );
}

const styles = {
  containerStyle: {
    my: 0,
    mx: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 0,
    width: 600
  },
  boxItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: 0,
    width: 450
  },
  linkItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: 0,
    mt: 2,
    mb: 4
  },
  linkTextStyle: {
    color: '#003087'
  },
  errorText: {
    color: '#F6323E',
    fontWeight: 'normal',
    fontSize: 14,
    marginBottom: 10,
    marginTop: 6,
    textAlign: 'left',
    marginLeft: 0
  }
};
